import React from "react";

import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import { HorizontalNavBar } from "components/HorizontalNavBar/HorizontalNavBar";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import { Routes } from "constants/routes";
import { RoleName } from "constants";
import { useUserRoleSelector } from "store";

const CLIENTS_ALLOWED_ROLES = [RoleName.Admin, RoleName.Analyst, RoleName.TeamViewer];

export const NavigationTabs = () => {
  const userRole = useUserRoleSelector();
  const showClientsTab = userRole?.name ? CLIENTS_ALLOWED_ROLES.includes(userRole.name as string) : false;

  return (
    <HorizontalNavBar
      tabs={[
        {
          value: "users",
          label: "Users",
          icon: <PermIdentityOutlinedIcon />,
          to: Routes.users,
          matchRouts: [Routes.users]
        },
        {
          value: "clients",
          label: "Clients",
          icon: <PeopleOutlinedIcon />,
          to: Routes.clients,
          matchRouts: [Routes.clients],
          hidden: !showClientsTab
        }
      ]}
    />
  );
};
